document.addEventListener('DOMContentLoaded', function () {
  const WISHLIST_KEY = 'shopify-wishlist';

  function getWishlist() {
    const stored = localStorage.getItem(WISHLIST_KEY);
    return stored ? JSON.parse(stored) : [];
  }

  function saveWishlist(items) {
    console.log('saveWishlist', items);
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function toggleWishlist(handle) {
    let items = getWishlist();
    let message = '';
    if (items.includes(handle)) {
      items = items.filter(h => h !== handle);
    } else {
      items.push(handle);
    }
    console.log(items);
    saveWishlist(items);
    updateAllButtons();

    window.renderWishlistSection();
  }
  
  function updateAllButtons() {
    const items = getWishlist();
    //console.log('updateAllButtons', items)
    document.querySelectorAll('.wishlist-button[data-product-handle]').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (items.includes(handle)) {
        btn.classList.add('active');
        btn.setAttribute('aria-label', 'Remove from Wishlist');
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-label', 'Add to Wishlist');
      }
    });
    updateHeaderIcon(items.length);
  }

  function updateHeaderIcon(count) {
    const headerBtn = document.querySelector('.header-wishlist-button');
    if (!headerBtn) return;
    if (count > 0) {
      headerBtn.classList.add('active');
    } else {
      headerBtn.classList.remove('active');
    }
  }

  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('.wishlist-button[data-product-handle]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.getAttribute('data-product-handle');
    console.log(handle);
    toggleWishlist(handle);
  });

  updateAllButtons();
});